module.exports = __webpack_public_path__ + "static/media/Galeri_24.456bda99.jpg";